export default {"src":"/_next/static/media/biljart.f8bf556b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};